module.exports = __webpack_public_path__ + "static/media/img-create-package.d17e87f8.png";